<script lang='ts'>
    export let taper: number

    function getEventReadinessTag(value: number) {
        return value < 2 
        ? "Excellent" 
        : value < 3 
        ? "Good" 
        : value < 4 
        ? "Fair"
        : value < 5
        ? "Poor"
        : "Not Ready"
    }
</script>

<div class="inline-flex items-baseline gap-1 border-solid border rounded-full px-5 py-1 w-36 border-slate-600">
    <div 
        class="font-bold text-3xl"
        class:text-green-600={taper < 2 && taper >= 1}
        class:text-blue-600={taper < 3 && taper >= 2}
        class:text-yellow-600={taper < 4 && taper >= 3}
        class:text-red-600={taper < 5 && taper >= 4}
        class:text-purple-600={taper >= 5}
    >
        {taper}
    </div>
    <span class="text-sm text-slate-600">{getEventReadinessTag(taper)}</span>
</div>